import { render, staticRenderFns } from "./IrisCSP.vue?vue&type=template&id=16ba437d&scoped=true&"
import script from "./IrisCSP.vue?vue&type=script&lang=js&"
export * from "./IrisCSP.vue?vue&type=script&lang=js&"
import style0 from "./IrisCSP.vue?vue&type=style&index=0&id=16ba437d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba437d",
  null
  
)

export default component.exports